import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppData } from '@shared/models/appdata.model';
import { Dealer, Seller, CreateSellerRequest } from '../models/dealer.model';

@Injectable({
  providedIn: 'root',
})
export class DealerService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = this.appData.apiUrl + '/api/v1';

  getDealersByUserId(userId: string): Observable<Dealer[]> {
    const url = `${this.apiUrl}/dealer/dealers?userId=${userId}`;
    return this.http.get<Dealer[]>(url);
  }

  getAllDealers(): Observable<Dealer[]> {
    const url = `${this.apiUrl}/dealer/all-dealers`;
    return this.http.get<Dealer[]>(url);
  }

  getSellers(): Observable<Seller[]> {
    const url = `${this.apiUrl}/dealer/sellers`;
    return this.http.get<Seller[]>(url);
  }

  createSeller(seller: CreateSellerRequest): Observable<Object> {
    const url = `${this.apiUrl}/dealer/seller`;
    return this.http.post(url, seller);
  }

  sellerSearch(searchPhrase: string): Observable<Seller[]> {
    const url = `${this.apiUrl}/dealer/sellers/search/${searchPhrase}`;
    return this.http.get<Seller[]>(url);
  }

  removeSellerFromDealer(userId: string): Observable<void> {
    const url = `${this.apiUrl}/dealer/sellers/${userId}`;
    return this.http.delete<void>(url);
  }
}
